module.exports = __webpack_public_path__ + "static/media/correct8.1c696dec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/correct8.svg
// module id = 530
// module chunks = 0